import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Table } from '../../../../common/table'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'
import { VALUE_TABLE_LATEST_REPORTS } from '../constant'
import {
  getDataFromReduxTableReports,
  getFilterTable,
  getLoadingReport,
  selectIdsTable,
  selectTypeReport,
} from '../store/slice'
import { getReports } from '../store/thunk'
import { CustomTdName } from './components/CustomSchema'
import { FilterLatestReports } from './components/Filter'
import { HeaderLatestReports } from './components/Header'
import { PaginationTableReport } from './components/Pagination'

export const LatestReportsTable = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const filter = useSelector(getFilterTable())
  const typeReport = useSelector(selectTypeReport)
  const loadingReport = useSelector(getLoadingReport('getReports'))

  const ids = useSelector(selectIdsTable)

  //UseEffect
  useEffect(() => {
    dispatch(
      getReports({
        ...filter,
        ReportType: typeReport.value,
      }),
    )
  }, [locale, filter, typeReport.value])

  return (
    <Element
      className="wh100 dFlex justifyContentCenter"
      style={{
        backgroundColor: '#E5E5E5',
      }}
    >
      <Element
        className="h100 flexColumn"
        style={{
          backgroundColor: '#FFFFFF',
          padding: '16px 24px',
          width: 1000,
        }}
      >
        <HeaderLatestReports />
        <FilterLatestReports />
        <div className="flex1 positionRelative">
          {loadingReport ? (
            <Loading />
          ) : (
            <Table
              ids={ids}
              getDataFromRedux={getDataFromReduxTableReports}
              schema={VALUE_TABLE_LATEST_REPORTS.map((item, index) => {
                const result = {
                  title: <Translate value={item.value} />,
                  colId: item.key,
                  thStyle: {
                    textTransform: 'capitalize',
                  },
                }
                if (index === 0) {
                  return {
                    ...result,
                    render: (val, { rowId }) => {
                      return <CustomTdName value={val} rowId={rowId} />
                    },
                  }
                }
                if (index === 2) {
                  return {
                    ...result,
                    tdStyle: {
                      whiteSpace: 'nowrap',
                    },
                    render: (val, { locale }) => {
                      return formatDateTime(val, FORMAT.DATE, locale)
                    },
                  }
                }
                return {
                  ...result,
                  tdStyle: {
                    whiteSpace: 'nowrap',
                  },
                  render: (val) => {
                    return formatText(val)
                  },
                }
              })}
              renderPagination={() => <PaginationTableReport />}
            />
          )}
        </div>
      </Element>
    </Element>
  )
}
